const routes = [
    {
        path: '/chat/:pid',
        async lazy() {
            const { ChatScreen } = await import(
            /* webpackChunkName: "chat" */
            './ChatLazyLoader');
            return { Component: ChatScreen };
        },
    },
];
export default routes;
